import { registerPlugin } from '@capacitor/core';

interface HostedLinkPlugin {
  open(options: { url: string; callbackScheme: string }): Promise<{ url: string }>;
}

export const HostedLink = registerPlugin<HostedLinkPlugin>('HostedLink');
